"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _purchaseLoginBg = _interopRequireDefault(require("./resources/purchaseLoginBg.svg"));
var _purchaseLoginMobileBg = _interopRequireDefault(require("./resources/purchaseLoginMobileBg.svg"));
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    _props$isWithPurchase = props.isWithPurchase,
    isWithPurchase = _props$isWithPurchase === void 0 ? false : _props$isWithPurchase;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    scrollProps = _useStylesUtils.scrollProps;
  var ccLoginStyle = (0, _react.useMemo)(function () {
    var mobileLayoutProps = function mobileLayoutProps() {
      if (layout === 'inline' && isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    var purchaseMobileProps = function purchaseMobileProps() {
      if (isWithPurchase) {
        if (isMobileView) {
          return {
            backgroundImage: "url(".concat(_purchaseLoginMobileBg.default, ")"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center'
          };
        }
        return {
          borderRadius: pxToRem(10),
          height: pxToRem(420),
          backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
          backgroundImage: "url(".concat(_purchaseLoginBg.default, ")"),
          backgroundSize: '70%',
          backgroundPosition: 'top 50% right -1%',
          display: 'flex',
          justifyContent: 'space-between'
        };
      } else {
        if (isMobileView) {
          return {
            display: 'flex',
            justifyContent: 'center',
            height: '100%'
          };
        }
        return {
          borderRadius: pxToRem(10),
          // aspectRatio: '9/6',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        };
      }
    };
    var loginSectionPurchaseMobileProps = function loginSectionPurchaseMobileProps() {
      if (isWithPurchase && isMobileView) {
        return {
          height: '50%'
        };
      }
      return {};
    };
    var buttonsPurchaseProps = function buttonsPurchaseProps() {
      if (isWithPurchase) {
        return {
          margin: '0 auto'
        };
      }
      return {};
    };
    var ccLogin = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily
    }, mobileLayoutProps()));
    var ccLoginContent = (0, _css.css)(_objectSpread(_objectSpread({
      overflow: 'auto',
      backgroundRepeat: 'no-repeat',
      padding: pxToRem(40)
    }, scrollProps()), purchaseMobileProps()));
    var ccLoginSection = (0, _css.css)(_objectSpread({
      paddingTop: isWithPurchase ? pxToRem(10) : ''
    }, loginSectionPurchaseMobileProps()));
    var ccLoginButtons = (0, _css.css)(_objectSpread({
      width: pxToRem(290),
      height: pxToRem(245),
      position: 'relative'
    }, buttonsPurchaseProps()));
    var ccLoginTitlePurchase = (0, _css.css)({
      marginBlockEnd: pxToRem(20)
    });
    var ccLoginTitleContainer = (0, _css.css)({
      marginBlockEnd: pxToRem(20),
      h1: {
        margin: 0,
        fontSize: pxToRem(54),
        lineHeight: pxToRem(50),
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        textAlign: 'center',
        marginBlockEnd: pxToRem(5)
      },
      h3: {
        margin: 0,
        color: '#545454',
        fontSize: pxToRem(26),
        lineHeight: pxToRem(30),
        fontWeight: 'normal',
        textAlign: 'center'
      }
    });
    var ccLoginIdmBtn = (0, _css.css)({
      '&:focus-visible': {
        border: '3px solid black'
      }
    });
    var ccLoginCetBtn = (0, _css.css)({
      marginTop: pxToRem(30),
      '&:focus-visible': {
        border: '3px solid black'
      }
    });
    var ccLoginIdmDesc = (0, _css.css)({
      fontSize: pxToRem(17),
      color: isWithPurchase ? '#fff' : themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      textAlign: 'center',
      lineHeight: pxToRem(17)
    });
    return {
      ccLogin: ccLogin,
      ccLoginContent: ccLoginContent,
      ccLoginSection: ccLoginSection,
      ccLoginButtons: ccLoginButtons,
      ccLoginTitlePurchase: ccLoginTitlePurchase,
      ccLoginTitleContainer: ccLoginTitleContainer,
      ccLoginIdmBtn: ccLoginIdmBtn,
      ccLoginCetBtn: ccLoginCetBtn,
      ccLoginIdmDesc: ccLoginIdmDesc
    };
  }, [fontFamily, isMobileView, isWithPurchase, layout, pxToRem, scrollProps, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-Login': ccLoginStyle.ccLogin,
    'cc-Login__content': ccLoginStyle.ccLoginContent,
    'cc-Login__login-section': ccLoginStyle.ccLoginSection,
    'cc-Login__buttons': ccLoginStyle.ccLoginButtons,
    'cc-Login__title-purchase': ccLoginStyle.ccLoginTitlePurchase,
    'cc-Login__title_container': ccLoginStyle.ccLoginTitleContainer,
    'cc-Login__idm_btn': ccLoginStyle.ccLoginIdmBtn,
    'cc-Login__cet_btn': ccLoginStyle.ccLoginCetBtn,
    'cc-Login__idm_desc': ccLoginStyle.ccLoginIdmDesc
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;